var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeShow)?_c('div',{ref:"goTop",staticClass:"goTop",on:{"click":_vm.goTopClick}},[_c('i',{staticClass:"el-icon-caret-top"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }